import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-placeholder',
  templateUrl: './placeholder.component.html',
  styleUrls: ['./placeholder.component.scss']
})
export class PlaceholderComponent {
@Input() background: string = '#ccc';
@Input() clazz: string = ''
@Input() height: string = '30px'
@Input() width: string = ''
}
